<script setup lang="ts">
import { defineProps, toRef } from "vue";
import { useGridGenerator } from "@/views/Calculators/ApartmentPlan/composables/useGridGenerator";
import { BoundingBox } from "@/types/stage";

const props = defineProps<{
  boundingBox: BoundingBox | null;
}>();

const boundingBoxRef = toRef(props, "boundingBox");

const { gridLines } = useGridGenerator(
  boundingBoxRef,
  3,
  2,
  "orange",
  "orange"
);
</script>

<template>
  <v-line v-for="(line, i) in gridLines" :key="'grid-' + i" :config="line" />
</template>
